/**
 * Les trois onglets de l'espace client. Une seule liste, lue par la barre
 * d'onglets desktop, le menu mobile et le héro.
 *
 * `/mes-devis` et non `/devis` : ce dernier est le formulaire public de demande
 * de devis, référencé depuis WordPress — il ne bouge pas.
 */
export const CLIENT_TABS = [
  { label: 'Dossiers', segment: '', to: '/' },
  { label: 'Devis', segment: 'mes-devis', to: '/mes-devis' },
  { label: 'Mon profil', segment: 'mon-profil', to: '/mon-profil' },
] as const

export type ClientTabValue = (typeof CLIENT_TABS)[number]['segment']

/**
 * Onglet actif déduit du premier segment de l'URL. Tout ce qui n'est ni
 * `mes-devis` ni `mon-profil` retombe sur Dossiers : le détail d'un dossier
 * (`/mes-reservations/:ref`, `/booking/:ref`) garde bien son onglet allumé.
 */
export function resolveActiveClientTab(pathname: string): ClientTabValue {
  const segment = pathname.split('/')[1] ?? ''
  const match = CLIENT_TABS.find((tab) => tab.segment !== '' && tab.segment === segment)
  return match?.segment ?? ''
}
